/**
 * ConfirmationModal - Wrapper para el componente global
 *
 * Este componente envuelve el ConfirmationModal global para mantener
 * compatibilidad con el código existente del panel de inventario.
 * Usa el diseño estándar (blanco, icono centrado, mismo estilo que otros modales).
 */

import React from 'react';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { ConfirmationModal as GlobalConfirmationModal } from '../../../ui/Modal';

export interface ConfirmationModalProps {
  isOpen: boolean;
  status: string | null;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
  onCompleteConfirmation?: () => void;
  onCompleteCancellation?: () => void;
  onReset: () => void;
  loading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  message,
  onCancel,
  onConfirm,
  onReset,
  loading = false,
}) => {
  return (
    <GlobalConfirmationModal
      open={isOpen}
      onClose={onReset || onCancel}
      onConfirm={onConfirm}
      title="¿Confirmar registro?"
      message={message}
      confirmText="Confirmar"
      cancelText="Cancelar"
      icon={<CheckCircleIcon />}
      variant="default"
      loading={loading}
    />
  );
};

export default ConfirmationModal;
